import IActivityLogEntry, {
  ActivityLogRole,
  ActivityLogStatus,
} from "../interface/iActivityLogEntry";

export const AREA_LABELS: Record<string, string> = {
  authentication: "Anmeldung",
  password: "Passwort",
  registration: "Registrierung",
  appointment: "Termin",
  booking: "Buchung",
  cancellation: "Stornierung",
  file: "Datei",
  rating: "Bewertung",
  user_management: "Nutzerverwaltung",
  coach: "Coach",
  admin_rights: "Admin-Rechte",
  anonymization: "Anonymisierung",
  reminder: "Erinnerung",
};

const ACTION_LABELS: Record<string, string> = {
  login: "Login",
  logout: "Logout",
  reset_requested: "Zurücksetzen angefordert",
  changed: "Geändert",
  registered: "Registriert",
  created: "Angelegt",
  imported: "Importiert",
  deleted: "Gelöscht",
  booked: "Gebucht",
  cancelled: "Storniert",
  goodwill_cancelled: "Kulanz-Storno",
  marked_missed: "Als versäumt markiert",
  marked_booked: "Wieder als gebucht markiert",
  uploaded: "Hochgeladen",
  downloaded: "Heruntergeladen",
  submitted: "Abgegeben",
  data_changed: "Daten geändert",
  active_status_changed: "Aktiv-Status geändert",
  default_password_set: "Standardpasswort gesetzt",
  edited: "Bearbeitet",
  binding_released: "Coachbindung aufgehoben",
  granted: "Vergeben",
  revoked: "Entzogen",
  anonymized: "Anonymisiert",
  sent: "Versendet",
};

export const getAreaLabel = (area: string): string => AREA_LABELS[area] ?? area;

export const getActionLabel = (action: string): string =>
  ACTION_LABELS[action] ?? action;

export const getRoleLabel = (role: ActivityLogRole | null): string =>
  role ?? "Unbekannt";

export const getStatusLabel = (status: ActivityLogStatus): string =>
  status === "success" ? "Erfolgreich" : "Fehlgeschlagen";

/** Failed logins have no actor, only the email that was typed in. */
export const getActorLabel = (entry: IActivityLogEntry): string => {
  if (entry.actor) {
    return entry.actor.name ?? `Nutzer ${entry.actor.id}`;
  }

  const loggedEmail = entry.details.email;

  if (typeof loggedEmail === "string" && loggedEmail !== "") {
    return loggedEmail;
  }

  return getRoleLabel(entry.actorRole);
};
